import {defineStore} from 'pinia'
import axios from 'axios'

export const useGlobalLoaderStore = defineStore('globalLoader', {
    state: () => ({
        loading: false,
        textContent: 'Chargement...',
    }),
    getters: {},
    actions: {
        start() {
            this.loading = true
        },
        stop() {
            this.loading = false
        },
        toggle() {
            this.loading = !this.loading
        }
    },
})
